import { Component } from '@angular/core';
interface Image {
  src: string;
  thumbnail: string;
  alt: string;
}
@Component({
  selector: 'app-events-euphoria',
  templateUrl: './events-euphoria.component.html',
  styleUrls: ['./events-euphoria.component.scss'],
})
export class EventsEuphoriaComponent {
  images: Image[] = [
    {
      src: 'assets/img/school/events/euphoria/1.jpg',
      thumbnail: 'assets/img/school/events/euphoria/1.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/euphoria/2.jpg',
      thumbnail: 'assets/img/school/events/euphoria/2.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/euphoria/3.jpg',
      thumbnail: 'assets/img/school/events/euphoria/3.jpg',
      alt: 'Image 01',
    },
  ];
}
